import { CalendarDays, MapPin, Briefcase, Users, UserPlus, CalendarClock, LucideIcon } from 'lucide-react'
import { SetupStepId } from './eventSetupStatus'

/**
 * Icons live here rather than in eventSetupStatus.ts so that module stays free
 * of UI dependencies and can be unit tested on its own.
 */
export const SETUP_STEP_ICONS: Record<SetupStepId, LucideIcon> = {
  basics: CalendarDays,
  locations: MapPin,
  positions: Briefcase,
  roles: Users,
  staff: UserPlus,
  shifts: CalendarClock,
}
